"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
var _constants = _interopRequireDefault(require("./constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let {
  URLs
} = _constants.default;
class ServiceHandler extends _ApiHandler.default {
  constructor() {
    super(...arguments);
    _defineProperty(this, "baseUrl", URLs.SERVICE);
  }
  emailTransactions() {
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to recalculate.');
      return;
    }
    let url = "".concat(this.baseUrl, "/email-trans/").concat(ac);
    return new Promise((resolve, reject) => {
      this.getInstance().post(url).then(response => {
        //this.showSuccess(response.data.message);
        resolve(true);
      }).catch(err => this.handleError(err, "Error while emailing account transactions. Try again."));
    });
  }
  stmtPreviewAction(accountId) {
    let url = "".concat(URLs.STATEMENT, "/preview/ac/").concat(accountId);
    return new Promise((resolve, reject) => {
      this.getInstance().get(url).then(response => {
        let html = response.data;
        let previewTab = window.open("/statement-preview/ac/".concat(accountId));
        previewTab.document.write(html);

        //to inject pdf instead use	
        // previewTab.document.write("<html<head><title>"+fileName+"</title><style>body{margin: 0px;}</style></head>");
        // previewTab.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(base64Data)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
        previewTab.document.close();

        // //this.showSuccess(response.data.message);
        resolve(true);
      }).catch(err => this.handleError(err, "Error while previewing account statement. Try again."));
    });
    // this.comp.setState({
    // 	openOverlay: true
    // })
    // this.reorderAccount().finally(()=>{
    // this.getInstance().get(`${URLs.STATEMENT}/preview/ac/${ac._id}`)
    // .then((response)=>{
    // 	let html = response.data;
    // 	let previewTab = window.open(`/statement-preview/ac/${ac._id}`);
    // 	previewTab.document.write(html);

    // 	//to inject pdf instead use	
    // 	// previewTab.document.write("<html<head><title>"+fileName+"</title><style>body{margin: 0px;}</style></head>");
    // 	// previewTab.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(base64Data)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
    // 	previewTab.document.close();
    // })
    // .finally(()=>{
    // 	this.comp.setState({
    // 		openOverlay: false
    // 	})
    // })
    // })
  }
}
exports.default = ServiceHandler;